import React from "react";
import { useConfig } from "../../contexts/ConfigContext";
import { useLanguage } from "../../contexts/LanguageContext";
import "./ProgressBar.css";

const ProgressBar: React.FC = () => {
  const { config } = useConfig();
  const { t } = useLanguage();

  // Steps based on your Step enum
  const allSteps = [
    { id: "preliminary_model", name: t("preliminary_model") },
    { id: "consultation", name: t("consultation") },
    { id: "model_finalization", name: t("model_finalization") },
    { id: "final_approval", name: t("final_approval") },
    { id: "manufacturing", name: t("manufacturing") },
    { id: "delivery", name: t("delivery") },
  ];

  const currentStepId = config?.step || "preliminary_model";
  const currentStepIndex = allSteps.findIndex(
    (step) => step.id === currentStepId
  );

  return (
    <div className="progress-container">
      <div className="progress-bar">
        {allSteps.map((step, index) => (
          <div
            key={step.id}
            className={`progress-step ${
              index < currentStepIndex
                ? "completed"
                : index === currentStepIndex
                ? "active"
                : ""
            }`}
            title={step.name}
          />
        ))}
      </div>
      {config && (
        <div className="progress-info">
          {t("step_word")} {currentStepIndex + 1} {t("of")} {allSteps.length}:{" "}
          {allSteps[currentStepIndex]?.name || "Unknown"}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
